var map = {
	"./available-banks.svg": 8147,
	"./available-coins.svg": 6943,
	"./coin-list.svg": 7594,
	"./otc.svg": 3188,
	"./overall.svg": 8505,
	"./pairs.svg": 2757,
	"./remove-2fa.svg": 7819,
	"./robots.svg": 1816,
	"./roles.svg": 3822,
	"./tokens.svg": 5413,
	"./transfer-setting.svg": 2528,
	"./user-accepted.svg": 4872,
	"./user-levels.svg": 7234,
	"./wages.svg": 9512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1347;